import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { getInputFieldHeightValue, InputFieldBaseProps } from "../../../../util/inputFieldBaseProps";
import { withFocusToggleClassName } from "../../../../util/withFocusClassName";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { formInputTheme } from "../../../textinput/styled/formInputTheme";
import { selectV2Theme } from "../selectV2Theme";

export interface ComboBoxInputProps extends InputFieldBaseProps {
    themeMode: RequiredThemeKeys;
    isContentBeforeVisible?: boolean;
    isReadonly?: boolean;
}

export const ComboBoxInput = withFocusToggleClassName(styled("input")<ComboBoxInputProps>`
    display: block;
    width: 100%;
    // Override some UA styles.
    font-family: inherit;
    color: ${color("color--text--neutral--strong")};
    font-size: ${({ themeMode }) => menuTheme.fontSize(themeMode)};
    line-height: 18px;
    padding: ${({ isContentBeforeVisible, themeMode }) =>
        isContentBeforeVisible ? "0 0 0 0" : `0 0 0 ${selectV2Theme.input.padding.left(themeMode)}`};
    height: ${({ themeMode, inputFieldHeight }) =>
        `var(--sds--form--height--${inputFieldHeight === 32 ? "default" : "large"}, ${formInputTheme.height[
            getInputFieldHeightValue(themeMode, inputFieldHeight)
        ](themeMode)}px)`};
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;

    // To show over the selected value facade.
    z-index: 1;

    border: 0px;
    background-color: transparent;
    cursor: inherit;

    &:focus,
    &:focus-visible {
        outline: none;
    }
`);
